module.exports = __webpack_public_path__ + "static/media/Avenir-LightOblique.d546a9cc.woff";